import { useState, useEffect } from 'react';
import { helpers } from '@adc/core-utils';
const canUseDom = () => helpers.environments.canUseDom();
const DEFAULT_DIMENSIONS = {
    height: 0,
    width: 0,
};
function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
}
export default function useWindowDimensions() {
    const dimensions = canUseDom() ? getWindowDimensions() : DEFAULT_DIMENSIONS;
    const [windowDimensions, setWindowDimensions] = useState(dimensions);
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return windowDimensions;
}
//# sourceMappingURL=index.js.map